export const adminSearchOrganisationQuery = "adminSearchOrganisationQuery";
export const adminUsersSearchQuery = "adminUsersSearchQuery";
export const adminAccountDetailsQuery = "adminAccountDetailsQuery";
export const adminUserOrgMembership = "adminUserOrgMembership";
export const adminOrganisationDetailsQuery = "adminOrganisationDetailsQuery";

export const availableSubscriptions = "availableSubscriptions";
export const adminOrganisationMembers = "adminOrganisationMembers";
export const adminUserApiKeys = "adminUserApiKeys";
export const adminUserApiKey = "adminUserApiKey";
export const adminUserMemberships = "adminUserMemberships";
export const adminDemosKey = "adminDemos";
export const networkAccessibility = "networkAccessibility";
export const apiKeys = "apiKeys";
export const apiProducts = "apiProducts";
export const subscription = "subscription";
export const billingUsage = "billingUsage";
export const userStatus = "userStatus";
export const latestVersion = "latestVersion";
export const plans = "plans";
export const paymentMethod = "paymentMethod";
export const dailyUsage = "dailyUsage";
export const datasetsSearchQuery = "datasetsSearchQuery";
export const customDatasetsSearchQuery = "customDatasetsSearchQuery";

export const customDatasetDefinitions = "datasetsCustomDefinitions";
export const adminCustomDatasetDefinitions = "adminCustomDatasetsDefinitions";
export const adminCustomDatasetsSearchQuery = "adminCustomDatasetsSearchQuery";
export const adminCustomDatasets = "adminCustomDatasets";
export const releasesDatasetsQuery = "releasesDatasetsQuery";
export const DatumValuesSearchQuery = "DatumValuesSearchQuery";

export const usageGraph = "usageGraph";
export const organisation = "organisation";
export const organisationMemberAccount = "organisationMemberAccount";
export const organisationMemberDetails = "organisationMemberDetails";
export const overage = "overage";
export const datasetsAccessibility = "datasetsAccessibility";

export const userInvitations = "userInvitations";
export const organisationInvitations = "organisationInvitations";

export const definitionsKey = "datasetDefinitions";
export const catalogueEntryKey = "catalogueEntry";
export const catalogueListKey = "catalogueList";

export const userLicences = "userLicences";
export const adminUserLicences = "adminUserLicences";
export const intercomIdentityHash = "intercomIdentityHash";

export const addressById = "addressById";
export const adminBoundsById = "adminBoundsById";
export const jwt = "jwt";
export const mapsIndexJson = "mapsIndexJson";
export const mapsLayerJson = "mapsLayerJson"; // Use this with layer name

export const batchesKey = "batches";
export const batchesDefinitionsKey = "batchesDefinitions";
export const batchesAdditionalPropertiesKey = "batchesAdditionalProperties";
export const batchesQuoteJob = "batchesQuoteJob";
export const batchesQuotedBatchConfig = "batchesQuotedBatchConfig";
export const batchesStartJob = "batchesStartJob";
export const batchesStopJob = "batchesStopJob";

export const demosKey = "demos";
export const adminConnectors = "adminConnectors";
export const adminConnector = "adminConnector";
export const adminOrgSSHKey = "adminOrgSSHKey";
export const adminPipelines = "adminPipelines";
export const adminPipelineLastRun = "adminPipelineLastRun";
export const adminPipelineNextRun = "adminPipelineNextRun";
export const adminPipeline = "adminPipeline";

export const clipsKey = "clips";
export const adminClipsKey = "adminClips";
export const adminVaultKey = "adminVault";
export const adminPaymentMethodKey = "adminPaymentMethod";
export const adminSubscriptionKey = "adminSubscription";
export const adminPermissionsKey = "adminPermissions";
export const adminOrganisationInfoKey = "adminOrganisationInfo";
export const adminCreditsKey = "adminCredits";
export const clipSummaryKey = "clipSummary";
export const clipInvoiceKey = "clipInvoice";
export const clipConfigKey = "clipConfig";
export const batchesSampleResponse = "batchesSampleResponse";

export const landParcelsPropertiesKey = "landParcelsProperties";
export const landParcelsCadastresKey = "landParcelsCadastres";
export const buildingsKey = "buildings";
export const authenticatedUser = "authenticatedUser";
export const preferredMfa = "preferredMfa";

export const predictiveAddress = "predictiveAddress";
export const predictiveLocality = "predictiveLocality";
export const userMembership = "userMembership";

export const credits = "credits";
export const permissions = "permissions";
export const buildingsSample = "buildingsSample";
export const cognitoRole = "cognitoRole";
export const deploymentStatus = "deploymentStatus";
